const assetsEn = {
    asset: require('../../lang/en/assets/Asset').default,
    assetIssue: require('../../lang/en/assets/AssetIssue').default,
    inventory: require('../../lang/en/assets/Inventory').default,
    amc: require('../../lang/en/assets/Amc').default,
}

export default assetsEn;

